import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import ModalTypes from '../../../constants/ModalTypes';

export function* updatePointSystemInCurrentBoard(isEnabled) {
  const { boardId } = yield select(selectors.selectPath);

  yield put(
    actions.updateBoard(boardId, {
      isPointSystemEnabled: isEnabled,
    }),
  );

  let board;
  try {
    ({ item: board } = yield call(request, api.updateBoard, boardId, {
      isPointSystemEnabled: isEnabled,
    }));
  } catch (error) {
    yield put(actions.updateBoard.failure(boardId, error));
    return;
  }

  yield put(actions.updateBoard.success(board));

  if (!isEnabled) {
    return;
  }

  let pointSystem = yield select(selectors.selectBoardLevelPointSystemForCurrentBoard);
  if (!pointSystem) {
    yield put(actions.updateBoardPointSystem(boardId));
    try {
      ({ item: pointSystem } = yield call(request, api.updateBoardPointSystem, boardId, {}));
    } catch (error) {
      yield put(actions.updateBoardPointSystem.failure(boardId, error));
      return;
    }
    yield put(actions.updateBoardPointSystem.success(pointSystem));
  }
}

export function* updateBoardPointSystemSettings(data = {}) {
  const pointSystem = yield select(selectors.selectPointSystemForSettingsModal);
  if (!pointSystem) {
    return;
  }

  const isGlobalTemplate =
    (pointSystem.projectId == null || pointSystem.projectId === '') &&
    (pointSystem.boardId == null || pointSystem.boardId === '');

  if (isGlobalTemplate) {
    yield put(actions.updateContentTypeTemplate(pointSystem.id, { ...data, syncLinked: true }));

    let item;
    let included = {};
    try {
      ({ item, included = {} } = yield call(request, api.updateContentTypeTemplate, pointSystem.id, {
        ...data,
        syncLinked: true,
      }));
    } catch (error) {
      yield put(actions.updateContentTypeTemplate.failure(pointSystem.id, error));
      return;
    }

    yield put(
      actions.updateContentTypeTemplate.success(item, {
        pointSystems: included.pointSystems || [],
      }),
    );
    return;
  }

  const { boardId } = yield select(selectors.selectPath);

  yield put(actions.updateBoardPointSystem(boardId, data));

  let updated;
  try {
    const response = yield call(request, api.updateBoardPointSystem, boardId, data);
    updated = response.item;
  } catch (error) {
    yield put(actions.updateBoardPointSystem.failure(boardId, error));
    return;
  }

  yield put(actions.updateBoardPointSystem.success(updated));
}

export function* openPointSystemModalInCurrentBoard() {
  yield call(fetchTemplatesAndOpenModal);
}

function* fetchTemplatesAndOpenModal() {
  const { boardId } = yield select(selectors.selectPath);

  // Всегда подтягиваем актуальный board PS с сервера (sourcePointSystemId)
  let boardPointSystem = yield select(selectors.selectBoardLevelPointSystemForCurrentBoard);

  if (boardId) {
    yield put(actions.updateBoardPointSystem(boardId));

    try {
      ({ item: boardPointSystem } = yield call(request, api.updateBoardPointSystem, boardId, {}));
    } catch (error) {
      yield put(actions.updateBoardPointSystem.failure(boardId, error));
      // Если ensure не удался — продолжаем с тем, что есть в сторе
      boardPointSystem = yield select(selectors.selectBoardLevelPointSystemForCurrentBoard);
    }

    if (boardPointSystem) {
      yield put(actions.updateBoardPointSystem.success(boardPointSystem));
    }
  }

  // load templates
  yield put(actions.fetchContentTypeTemplates());
  let items = [];
  let contentTypes = [];
  let pointSystems = [];
  try {
    const response = yield call(request, api.getContentTypeTemplates);
    items = response.items || [];
    contentTypes = (response.included && response.included.contentTypes) || [];
    pointSystems = (response.included && response.included.pointSystems) || [];
  } catch (error) {
    yield put(actions.fetchContentTypeTemplates.failure(error));
    return;
  }
  yield put(actions.fetchContentTypeTemplates.success(items, contentTypes, pointSystems));

  if (contentTypes.length > 0) {
    const byPs = contentTypes.reduce((acc, row) => {
      const key = String(row.pointSistemId);
      if (!acc[key]) acc[key] = [];
      acc[key].push(row);
      return acc;
    }, {});
    // eslint-disable-next-line no-restricted-syntax
    for (const [psId, list] of Object.entries(byPs)) {
      yield put(actions.fetchContentTypes.success(psId, list));
    }
  }

  // После upsert linked PS — перечитываем board PS из стора
  boardPointSystem = yield select(selectors.selectBoardLevelPointSystemForCurrentBoard);

  const sourceId = boardPointSystem?.sourcePointSystemId
    ? String(boardPointSystem.sourcePointSystemId)
    : null;

  // Если для доски выбран шаблон — всегда открываем именно его (в т.ч. скрытый)
  const appliedTemplate =
    sourceId && items.find((item) => String(item.id) === sourceId);

  const visible = items.filter((item) => item.isHidden !== true);
  const selectedTemplateId = appliedTemplate
    ? appliedTemplate.id
    : visible.find((item) => item.isDefault === true)?.id ||
      visible[0]?.id ||
      items[0]?.id ||
      null;

  yield put(
    actions.openModal(ModalTypes.POINT_SYSTEM, {
      mode: 'templates',
      selectedTemplateId: selectedTemplateId ? String(selectedTemplateId) : null,
    }),
  );
}

/** @deprecated */
export function* openPointSystemModalInCurrentProject() {
  yield call(openPointSystemModalInCurrentBoard);
}

export default {
  updatePointSystemInCurrentBoard,
  updateBoardPointSystemSettings,
  openPointSystemModalInCurrentBoard,
  openPointSystemModalInCurrentProject,
};
